import { gql } from 'graphql.macro';

export const GetObservationFileUrl = gql`
    query getFileUrlById($fileId: Int!, $referenceId: Uuid!) {
        retrieveSASForFile(fileId: $fileId, referenceId: $referenceId)
    }
`;